import { Dispatch, SetStateAction } from "react"
import ModalPortal from "../../Assets/ModalPortal/ModalPortal"
import Button from "../../Assets/Button/Button"
import { useScrollBlock } from "../../../hooks/useScrollBlock"
import { useTranslation } from "react-i18next"
import s from "./AnotherObjModal.module.scss"

interface Props {
  open: boolean
  setOpen: Dispatch<SetStateAction<boolean>>
  callbackSubmit: () => void
}

const AnotherObjModal = ({ open, setOpen, callbackSubmit }: Props) => {
  const { t } = useTranslation("translation", { keyPrefix: `interface` })
  const { allowScroll } = useScrollBlock()

  return (
    <ModalPortal isOpen={open} setIsOpen={setOpen} className={s.modal}>
      <h2 className={"modal__title"}>{t("scannedObjDiff")}.</h2>
      <div className={"modal__content"}>
        <p className={s.txt}>{t("canYouChangeObj")}</p>
        <footer className={s.footer}>
          <Button txt={t("replace")} onClick={callbackSubmit} />
          <Button
            txt={t("continue")}
            mode={"light"}
            onClick={() => {
              setOpen(false)
              allowScroll(true)
            }}
          />
        </footer>
      </div>
    </ModalPortal>
  )
}

export default AnotherObjModal
